module.exports = __webpack_public_path__ + "static/img/adv-initial-popup-contents-img.8930c5f.png";